
export class Label {

  constructor(
    public id: number,
    public category: string,
    public small_title: string,
    public title: string,
    public bit_mask: string
  ) {}
}
